import { createRoot } from 'react-dom/client';
import { KeyboardNavigation } from 'Shared/keyboard_navigation';
import { DevicePickerModal } from 'Shared/DevicePickerModal';
import { Initializer } from 'Shared/chakra-initialize';
import { initializeReactQuery } from 'Shared/react-query-initialize';

new KeyboardNavigation({
   keys: {
      '/': deviceNavigator,
   },
});

export default function deviceNavigator() {
   if (document.querySelector('[data-id="devicePickerComponent"]')) {
      return;
   }
   const node = document.createElement('div');
   document.body.appendChild(node);
   const root = createRoot(node);
   const DevicePickerWithChakra = new Initializer(DevicePickerModal);
   root.render(
      initializeReactQuery(
         <DevicePickerWithChakra
            defaultIsOpen={true}
            onSelect={device => (window.location.href = device.url)}
            treeNavigationProps={'showAreaButtons'}
         />
      )
   );
}
